import * as React from 'react';
import {
    Create,
    TextInput,
    NullableBooleanInput,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    required,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';

const DownloadCategoryCreate = () => {
    return (
        <Create redirect={'/download_categories'}>
            <SimpleForm>
                <TextInput source="name" fullWidth name={'name'} />
                <FileUpload
                    type="VIDEO_THUMBNAIL"
                    source={'thumbnail'}
                    required={true}
                    accept={'image/*'}
                />
                <TextInput source="display_order" type={'number'} fullWidth />
            </SimpleForm>
        </Create>
    );
};

export default DownloadCategoryCreate;
